const SETTINGS_BY_DOMAIN = {
  // ローカル環境
  'fcs.local': {
    logoImgPathAuth: '/images/member/logo-header-fcs.svg',
    logoImgPathHeader: '/images/member/logo-header-fcs.svg',
    pageSidebarClass: 'fcs-main-color',
  },
  // FCS
  'fcs-dev.aidiot.jp': {
    logoImgPathAuth: '/images/member/logo-header-fcs.svg',
    logoImgPathHeader: '/images/member/logo-header-fcs.svg',
    pageSidebarClass: 'fcs-main-color',
  },
  // FCS
  'fcs.aidiot.jp': {
    logoImgPathAuth: '/images/member/logo-header-fcs.svg',
    logoImgPathHeader: '/images/member/logo-header-fcs.svg',
    pageSidebarClass: 'fcs-main-color',
  },
}

/**
 * 認証画面 ロゴ画像のセット
 * @type {{data(): {logoImgPath: string}}}
 */
export const authLogoMixin = {
  data() {
    const domain = document.domain

    let logoImgPath = ''

    Object.keys(SETTINGS_BY_DOMAIN).forEach(k => {
      if (k === domain) {
        logoImgPath = SETTINGS_BY_DOMAIN[k].logoImgPathAuth
      }
    })

    if (logoImgPath === '') {
      logoImgPath = this.$constantMember.app_image.logo_img_path
    }

    return {
      logoImgPath,
    }
  },
}

/**
 * ヘッダー ロゴ画像のセット
 * @type {{data(): {logoImgPath: string}}}
 */
export const headerLogoMixin = {
  data() {
    const domain = document.domain

    let logoImgPath = ''

    Object.keys(SETTINGS_BY_DOMAIN).forEach(k => {
      if (k === domain) {
        logoImgPath = SETTINGS_BY_DOMAIN[k].logoImgPathHeader
      }
    })

    if (logoImgPath === '') {
      logoImgPath = this.$constantMember.app_image.logo_header_img_path
    }

    return {
      logoImgPath,
    }
  },
}

/**
 * サイドバーの背景色をセット
 * @type {{data(): {pageSidebarClassObj: {}}}}
 */
export const sidebarBgMixin = {
  data() {
    const domain = document.domain

    const pageSidebarClassWrapperObj = {}
    const pageSidebarClassObj = {}

    let isSet = false
    Object.keys(SETTINGS_BY_DOMAIN).forEach(k => {
      if (k === domain) {
        pageSidebarClassWrapperObj[SETTINGS_BY_DOMAIN[k].pageSidebarClass] = true
        pageSidebarClassObj[SETTINGS_BY_DOMAIN[k].pageSidebarClass] = true
        isSet = true
      }
    })

    if (!isSet) {
      pageSidebarClassWrapperObj['default-main-color'] = true
      pageSidebarClassObj['default-main-color'] = true
    }

    return {
      pageSidebarClassWrapperObj,
      pageSidebarClassObj,
    }
  },
}
